// extracted by mini-css-extract-plugin
export var buttons = "_a4-0";
export var buttonsActive = "_a4-h";
export var cancelConfirm = "_a4-1";
export var closeButton = "_a4-2";
export var column = "_a4-3";
export var container = "_a4-4";
export var detailHeader = "_a4-6";
export var detailTitle = "_a4-7";
export var detailsContent = "_a4-5";
export var header = "_a4-8";
export var headerWithClose = "_a4-9";
export var icon = "_a4-a";
export var infoIcon = "_a4-c";
export var informationContainer = "_a4-b";
export var sideDrawer = "_a4-d";
export var sideDrawerOpen = "_a4-e";
export var stickyFooter = "_a4-f";
export var typeOption = "_a4-g";